export enum PhaseStatus {
    COMPLETED = "COMPLETED",
    NEW = "NEW",
    FAILED = "FAILED",
    IN_PROGRESS = "IN_PROGRESS",
    NOT_STARTED = "NOT_STARTED",
    READY = "READY",
    REJECTED = "REJECTED",
    REOPENED = "REOPENED",
    SKIPPED = "SKIPPED",
}

export enum JobType {
    FEATURED = "FEATURED",
    AVAILABLE = "AVAILABLE",
    IN_PROGRESS = "IN_PROGRESS",
    COMPLETED = "COMPLETED",
}

export enum JobFilterType {
    CLAIMABLE = "CLAIMABLE",
    ONGOING = "ONGOING",
    NEW = "NEW",
    CONTINUE = "CONTINUE",
    DONE = "DONE"
}

export enum ProgressBarColors {
    COMPLETED = "#1C8843",
    IN_PROGRESS = "#2375BD",
    REJECTED = "#D62027",
    READY = "#E5EBEF"
}

export enum JobTag {
    REGULAR = "REGULAR",
    FEATURED = "FEATURED",
    OPEN = "OPEN",
    CLONE = "CLONE",
    GEOSPATIAL = "GEOSPATIAL",
    EXPIRED = "EXPIRED"
}

export enum JobNotification {
    REOPEN = "REOPEN",
    COMPLETE = "COMPLETE",
    REJECT = "REJECT",
    ERROR = "ERROR"
}
